"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Permission = exports.Role = exports.Mode = void 0;
var Mode;

(function (Mode) {
  Mode[Mode["impersonate"] = 900] = "impersonate";
  Mode[Mode["normal"] = 901] = "normal";
  Mode[Mode["shadow"] = 902] = "shadow";
})(Mode || (exports.Mode = Mode = {}));

var Role;

(function (Role) {
  Role[Role["Accounts Payable"] = 100] = "Accounts Payable";
  Role[Role["Buyer"] = 101] = "Buyer";
  Role[Role["Consumer"] = 102] = "Consumer";
  Role[Role["Customer Administrator"] = 103] = "Customer Administrator";
  Role[Role["Hickman Administrator"] = 104] = "Hickman Administrator";
  Role[Role["Inquirer"] = 105] = "Inquirer";
  Role[Role["ISR"] = 106] = "ISR";
  Role[Role["Market Intelligence"] = 107] = "Market Intelligence";
  Role[Role["MGT"] = 108] = "MGT";
  Role[Role["Order Status"] = 109] = "Order Status";
  Role[Role["OSR"] = 110] = "OSR";
  Role[Role["Report Only"] = 111] = "Report Only";
  Role[Role["Ryerson3.0Only"] = 112] = "Ryerson3.0Only";
  Role[Role["Store Administrator"] = 113] = "Store Administrator";
  Role[Role["Super Store Administrator"] = 114] = "Super Store Administrator";
  Role[Role["System Administrator"] = 115] = "System Administrator";
  Role[Role["Unregistered User"] = 116] = "Unregistered User";
  Role[Role["user"] = 117] = "user";
})(Role || (exports.Role = Role = {}));

var Permission;

(function (Permission) {
  Permission[Permission["Account_Settings"] = 500] = "Account_Settings";
  Permission[Permission["Account_Settings_Address_Shipping_Edit"] = 501] = "Account_Settings_Address_Shipping_Edit";
  Permission[Permission["Account_Settings_Advanced_Shipping_Notifications_View_Edit"] = 502] = "Account_Settings_Advanced_Shipping_Notifications_View_Edit";
  Permission[Permission["Account_Settings_Order_Acknowledgment_View_Edit"] = 503] = "Account_Settings_Order_Acknowledgment_View_Edit";
  Permission[Permission["Account_Settings_Payment_Types_View_Edit"] = 504] = "Account_Settings_Payment_Types_View_Edit";
  Permission[Permission["Admin_Portal_Magenium"] = 505] = "Admin_Portal_Magenium";
  Permission[Permission["Admin_Portal_Multiple_Account"] = 506] = "Admin_Portal_Multiple_Account";
  Permission[Permission["Billing_Address_Edit"] = 507] = "Billing_Address_Edit";
  Permission[Permission["Cart_View_Edit"] = 508] = "Cart_View_Edit";
  Permission[Permission["Customer_Account_View_Edit"] = 509] = "Customer_Account_View_Edit";
  Permission[Permission["Customer_Dashboard_View_Edit"] = 510] = "Customer_Dashboard_View_Edit";
  Permission[Permission["Document_Menu_View_Edit"] = 511] = "Document_Menu_View_Edit";
  Permission[Permission["Invoice_View_Pay"] = 512] = "Invoice_View_Pay";
  Permission[Permission["Onboarding_View_Edit"] = 513] = "Onboarding_View_Edit";
  Permission[Permission["Orders_Create"] = 514] = "Orders_Create";
  Permission[Permission["Orders_View"] = 515] = "Orders_View";
  Permission[Permission["Price_View"] = 516] = "Price_View";
  Permission[Permission["Quotes_View_Edit"] = 517] = "Quotes_View_Edit";
  Permission[Permission["Reports_Run_Download"] = 518] = "Reports_Run_Download";
  Permission[Permission["Reports_Store_Admin"] = 519] = "Reports_Store_Admin";
  Permission[Permission["Select_Batches_View"] = 520] = "Select_Batches_View";
  Permission[Permission["Shadow_Permissions"] = 521] = "Shadow_Permissions";
  Permission[Permission["Shopping_List_Share"] = 522] = "Shopping_List_Share";
  Permission[Permission["Shopping_List_View_Edit"] = 523] = "Shopping_List_View_Edit";
  Permission[Permission["Submit_Order"] = 524] = "Submit_Order";
  Permission[Permission["Subscribe_Save_View"] = 525] = "Subscribe_Save_View";
  Permission[Permission["User_Add"] = 526] = "User_Add";
  Permission[Permission["User_Management_View"] = 527] = "User_Management_View";
  Permission[Permission["User_Management_View_Edit"] = 528] = "User_Management_View_Edit";
})(Permission || (exports.Permission = Permission = {}));